import type { ImportTableColumn } from "./ImportTableColumn";

/** Visibility and required status of a single import-table column. */
export interface ColumnSetting {
	visible: boolean;
	required: boolean;
}

/** Configuration for columns whose visibility / required flag cannot be changed. */
export interface HardcodedColumnSetting {
	alwaysVisible?: boolean;
	alwaysRequired?: boolean;
}

/** Columns whose visibility and required flags are fixed (always-on / always-required). */
export const hardcodedColumns: Partial<Record<ImportTableColumn, HardcodedColumnSetting>> = {
	grower: { alwaysVisible: true, alwaysRequired: true },
	farm: { alwaysVisible: true },
	field: { alwaysVisible: true, alwaysRequired: true },
	boundaryGeoJSON: { alwaysVisible: true },
	pointsGeoJSON: { alwaysVisible: true },
	collectBoundary: { alwaysVisible: true },
	deal: { alwaysVisible: true, alwaysRequired: true },
	depth: { alwaysVisible: true, alwaysRequired: true },
	density: { alwaysVisible: true, alwaysRequired: true },
};
